import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { closeForm } from "../feature/formSlice";
import { callAPI } from "../feature/APISlice";
import { showMessage } from "../feature/navbarSlice";
import { fetchLookups } from "../feature/lookupSlice";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/about-us-mission-vision`;

const getDefaultFormData = () => ({
  title: "",
  description: "",
  orderNumber: "",
  image: "",
  is_active: false,
});

export default function AboutUsMissionVisionForm() {
  const dispatch = useDispatch();

  const { isOpen, editingId } = useSelector((s) => s.form);
  const { current, loading, error } = useSelector((s) => s.api);
  const { media } = useSelector((s) => s.lookups);

  const [formData, setFormData] = useState(getDefaultFormData());

  
  useEffect(() => {
    if (isOpen) {
      dispatch(fetchLookups());
    }
  }, [isOpen, dispatch]);

  useEffect(() => {
    if (editingId) {
      dispatch(callAPI({ method: "get", url: `${BASE_URL}/${editingId}` }));
    }
  }, [editingId, dispatch]);

  useEffect(() => {
    if (current && editingId) {
      setFormData({
        title: current.title ?? "",
        description: current.description ?? "",
        orderNumber: current.orderNumber ?? "",
        image: current.image?.rivid ?? "",
        is_active: current.is_active ?? false,
      });
    }

    if (!editingId) {
      setFormData(getDefaultFormData());
    }
  }, [current, editingId]);

  const mediaOptions = useMemo(
    () =>
      media.map((m) => ({
        value: m.rivid,
        label: `RIVID: ${m.rivid}`,
      })),
    [media]
  );

  const selectedMedia =
    mediaOptions.find((o) => o.value === Number(formData.image)) || null;

  const handleClose = () => {
    dispatch(closeForm());
    setFormData(getDefaultFormData());
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const method = editingId ? "patch" : "post";
      const url = editingId ? `${BASE_URL}/${editingId}` : BASE_URL;

      await dispatch(callAPI({ method, url, data: formData })).unwrap();

      dispatch(
        showMessage({
          type: "success",
          text: `Mission & Vision ${
            editingId ? "updated" : "created"
          } successfully`,
        })
      );

      handleClose();
    } catch (err) {
      dispatch(
        showMessage({
          type: "error",
          text: err || "Something went wrong",
        })
      );
    }
  };

  if (!isOpen) return null;
  return (
    <div className="admin-form-overlay">
      <div className="admin-form-wrapper" onClick={(e) => e.stopPropagation()}>
        <button className="admin-form-close" onClick={handleClose}>
          ✕
        </button>

        <h2>{editingId ? "Edit Mission & Vision" : "Add Mission & Vision"}</h2>

        <form className="admin-contact-form" onSubmit={handleSubmit}>
        
          <div className="admin-form-group">
            <label>Title</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => handleChange("title", e.target.value)}
            />
          </div>
          <div className="admin-form-group">
            <label>Description</label>
            <textarea
              rows={3}
              value={formData.description}
              onChange={(e) =>
                handleChange("description", e.target.value)
              }
            />
          </div>
          <div className="admin-form-group">
            <label>Order Number</label>
            <input
              type="text"
              value={formData.orderNumber}
              onChange={(e) =>
                handleChange("orderNumber", e.target.value)
              }
            />
          </div>

          <div className="admin-form-group">
            <label>Select Image (Media RIVID)</label>
            <Select
              options={mediaOptions}
              value={selectedMedia}
              onChange={(option) =>
                handleChange("image", option ? option.value : "")
              }
              isClearable
              placeholder="Select Media RIVID"
            />
          </div>

          <div className="admin-form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.is_active}
                onChange={(e) =>
                  handleChange("is_active", e.target.checked)
                }
              />{" "}
              Active
            </label>
          </div>
          <div className="admin-button-row">
            <button
              type="button"
              className="admin-btn outline"
              onClick={handleClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="admin-btn filled"
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : editingId
                ? "Update"
                : "Save"}
            </button>
          </div>

          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
      </div>
    </div>
  );
}
